export interface SituacaoImportacao {
  codigo: string;
  rotulo: string;
  descricao: string;
  categoria: string;
}

// Categoria -> cor do rótulo (design CON-4719): em andamento = ROXO (primary), erro = vermelho,
// falha/ocorrência = laranja/amarelo (warning), informação = azul (info), sucesso = verde.
const CATEGORIA_COR: Record<string, string> = {
  em_andamento: 'text-agnes-primary',
  erro: 'text-agnes-error',
  falha: 'text-agnes-warning',
  informacao: 'text-agnes-info',
  sucesso: 'text-agnes-success',
};

/**
 * Coluna "Situação" da tela de Importação (CON-4719): rótulo amigável colorido por categoria
 * + descrição em cinza embaixo, conforme o Figma. Espelha a mecânica do CentralReprocessamentoStatus.
 */
export function ImportacaoStatus({ situacao }: Readonly<{ situacao?: SituacaoImportacao | null }>) {
  if (!situacao) return <span className="text-agnes-text-muted">-</span>;
  const cor = CATEGORIA_COR[situacao.categoria] ?? 'text-agnes-text';
  return (
    <div className="flex flex-col gap-0.5" data-qa={`importacao-situacao-${situacao.codigo}`}>
      <span className={`text-sm font-medium ${cor}`}>{situacao.rotulo}</span>
      <span className="text-xs text-agnes-text-muted">{situacao.descricao}</span>
    </div>
  );
}
